module.exports = __webpack_public_path__ + "img/haibao.a6db14c5.png";